(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-products-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const mediaQuery = window.matchMedia('(max-width: 750px)');

  function initImageSwitcher(e) {
    const prodContainer = document.querySelector(".prod-container");
    const prodItems = document.querySelectorAll(".prod-items");

    if (e.matches) {
      const intervalTime =
        (parseInt(prodContainer?.dataset.interval_time, 10) * 1000) ?? 4000;
      
      if (intervalTime != 0) {
        prodItems.forEach((item) => {
          const firstImg = item.querySelector(".first-img");
          const secondImg = item.querySelector(".second-img");

          // 防止重复绑定
          if (firstImg && secondImg && !item.dataset.init) {
            item.dataset.init = "true";
            let showFirst = true;

            const timer = setInterval(() => {
              if (showFirst) {
                firstImg.style.display = "block";
                secondImg.style.display = "none";
                item.style.background = "";
              } else {
                firstImg.style.display = "none";
                secondImg.style.display = "block";
                item.style.background = "#FFF5ECB2";
              }
              showFirst = !showFirst;
            }, intervalTime);

            // 把定时器 id 保存到 dataset 里
            item.dataset.timerId = timer;
          }
        });
      }

    } else {
      // 不在范围内时清除定时器
      prodItems.forEach((item) => {
        if (item.dataset.timerId) {
          clearInterval(item.dataset.timerId);
          delete item.dataset.timerId;
          delete item.dataset.init;

          const firstImg = item.querySelector(".first-img");
          const secondImg = item.querySelector(".second-img");
          firstImg.style.display = "";
          secondImg.style.display = "";
        }
        
      });
    }
  }


  // 初始化时执行一次
  initImageSwitcher(mediaQuery);

  // 监听屏幕尺寸变化
  mediaQuery.addEventListener("change", initImageSwitcher);
});

  } catch(e) { console.error(e); }
})();
})();
